import { useState, useEffect, useContext } from 'react';
import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppContext, SttDialog, SttList } from '../../../sporttia/all';
import { formatPriceByLocale } from '../../../lib/utils';

/**
 *
 *	Props
 *
 *	* onSelect({rate,boleto})
 */
export default function BookingSelectRateDialog({
    open = false,
    fares,
    rateType,
    onClose,
    onSelect,
    isForGame = false,
    forceFullRates = false,
}: any) {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const [rates, setRates] = useState<any>();
    const [boletos, setBoletos] = useState<any>();

    /**
     * Set rates
     */
    useEffect(() => {
        if (fares) {
            // Si forceFullRates es true, siempre mostrar tarifas completas
            if (forceFullRates) {
                setRates(fares.fullRates);
                setBoletos(fares.fullBonos);
            } else if (isForGame) {
                setRates(fares.individualRates);
                setBoletos(fares.individualBonos);
            } else if (rateType === cxt.constants.RT_Individual) {
                setRates(fares.individualRates);
                setBoletos(fares.individualBonos);
            } else {
                setRates(fares.fullRates);
                setBoletos(fares.fullBonos);
            }
        } else {
            setRates(null);
            setBoletos(null);
        }
    }, [
        fares,
        rateType,
        isForGame,
        forceFullRates,
        cxt.constants.RT_Individual,
    ]);

    /**
     * Select rate / boleto
     */
    const selectRateBoleto = (p: any) => {
        onSelect(p);
        onClose();
    };

    // Render
    return (
        <SttDialog
            title={`${t('booking.rates')} & ${t('booking.bonos')}`}
            open={open}
            onClose={onClose}
            content={
                <>
                    {boletos && boletos.length > 0 && (
                        <Box mb={2}>
                            <SttList
                                paper
                                title={t('booking.bonos')}
                                onSelect={(boleto: any) =>
                                    selectRateBoleto({ boleto })
                                }
                                numRows={3}
                                data={boletos.map((boleto: any) => ({
                                    caption: `${boleto.bono.name} [ ${boleto.consumed} / ${boleto.amount} ]`,
                                    objToSelect: boleto,
                                }))}
                            />
                        </Box>
                    )}

                    {rates && rates.length > 0 && (
                        <SttList
                            paper
                            title={t('booking.rates')}
                            onSelect={(rate: any) => selectRateBoleto({ rate })}
                            numRows={3}
                            data={rates.map((rate: any) => ({
                                caption:
                                    rate &&
                                    rate.prices &&
                                    rate.prices.length > 0
                                        ? rate.prices.map((price: any) => (
                                              <Chip
                                                  key={price.id || price.name}
                                                  style={{
                                                      marginRight: 3,
                                                      marginTop: 3,
                                                  }}
                                                  size="small"
                                                  label={`${price.name} [ ${price.duration}m / ${formatPriceByLocale(
                                                      price?.price,
                                                      price?.priceShape
                                                          ?.currency,
                                                      price?.priceShape?.locale,
                                                  )} ]`}
                                              />
                                          ))
                                        : t('booking.noRates'),
                                objToSelect: rate,
                            }))}
                        />
                    )}
                </>
            }
            buttons={[
                {
                    type: 'close',
                    onClick: onClose,
                },
            ]}
        />
    );
}
